import connectFacebook from './facebook';
import connectTwitter from './twitter';
import connectInstagram from './instagram';
import connectYoutube from './youtube';
import connectInstagramBusiness from './instagramBusiness';

export {
  connectFacebook,
  connectTwitter,
  connectInstagram,
  connectYoutube,
  connectInstagramBusiness
};
